export type CardNetwork = "visa" | "mastercard" | "amex" | "unknown";

export function detectCardNetwork(number: string): CardNetwork {
  const digits = number.replace(/\D/g, "");
  if (/^4/.test(digits)) return "visa";
  if (/^(5[1-5]|2[2-7])/.test(digits)) return "mastercard";
  if (/^3[47]/.test(digits)) return "amex";
  return "unknown";
}

export function normalizeOppwaBrand(brand?: string): CardNetwork {
  if (!brand) return "unknown";
  const value = brand.toUpperCase();
  if (value.includes("VISA")) return "visa";
  if (value.includes("MASTER")) return "mastercard";
  if (value.includes("AMEX") || value.includes("AMERICAN")) return "amex";
  return "unknown";
}

export function formatCardNumberDisplay(raw: string): string {
  const digits = raw.replace(/[^\d#•]/g, "").slice(0, 16);
  const groups: string[] = [];
  for (let i = 0; i < 4; i += 1) {
    const chunk = digits.slice(i * 4, i * 4 + 4);
    groups.push((chunk + "••••").slice(0, 4));
  }
  return groups.join(" ");
}
